import styled from "styled-components";


export const ValidationStepContainer = styled.div`
  margin-top: 8rem;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

`;